// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "941" ? "__federation_expose_Widget" : chunkId) + "." + {"396": "24250830","437": "17da86be","531": "e006ad59","75": "8d321629","941": "71cff267",}[chunkId] + ".js"
}